import {Component, OnInit} from '@angular/core';
import {ajax} from 'jquery';
import {AsThreshold, Base64, FaceSDK, LocalizationMessage, SdkOptionsType, TransactionMode} from '@identy/identy-face';
import {ContextMenuHelperService} from '../title-bar/title-context-menu/context-menu-helper.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Router} from '@angular/router';
import {StorageService} from '../../../services/storage.service';
import {AlertController, LoadingController} from '@ionic/angular';
import {BidService} from '../../../services/bid.service';
import {environment} from '../../../../environments/environment';
import { BaseComponent } from 'src/app/base/base.component';
import { AuthService } from 'src/app/guards/auth.service';
import { PagesToNavigateService } from 'src/app/base/pages.service';


@Component({
  selector: 'app-sdk-run-face',
  templateUrl: './sdk-run.component.html',
  styleUrls: ['./sdk-run.component.css']
})
export class SdkRunComponent extends BaseComponent implements OnInit {

  urlIdentify = environment.urlBalanceador;
  bsModelPrgRef2: BsModalRef;
  bsModelTxnDialog: BsModalRef;
  coppelRoute: boolean;
  operationId;

  constructor(private contextMenuSelection: ContextMenuHelperService,
    private modalService: BsModalService,
    protected router: Router,
    private storage: StorageService,
    public alertController: AlertController,
    protected loadingController: LoadingController,
    private bidService: BidService,
    protected storageService: StorageService,
    protected authService: AuthService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    super(loadingController, router, storageService, alertController, authService, pagesToNavigateService)
  }




  ngOnInit() {

    this.storage.getStorage('operationID').then((op: any) => {

      this.operationId = op.value;
    });

    this.coppelRoute = this.router.url === '/coppel';

    function getUser() {
      let user = localStorage.getItem('lu');
      if (user === null) {
        user = 'delaerweeb';
        if (user === null || user === '') {
          getUser();
        } else {
          localStorage.setItem('lu', user);
        }
      }
    }

    getUser();
  }

  runTransaction(transaction: TransactionMode) {
    const selection = this.contextMenuSelection.selection;
    const options: SdkOptionsType = {
      localization: {
        en: {
          FEEDBACK_RETRY: 'Algo es extraño, cambia de ubicación',
          FEEDBACK_RETRY_QUALITY: 'Mala calidad, reintentar captura',
          FEEDBACK_ENROLLED: 'Registrado correctamente',
          FEEDBACK_CAPTURED: 'Capturado con éxito',
          FEEDBACK_NOT_ENROLLED: 'Usuario no enrolado',
          FEEDBACK_VERIFY_COMPLETED: 'Verificación exitosa',
          FEEDBACK_VERIFY_FAILED: 'Fallo en la verificación',
          FEEDBACK_SEARCHING: 'Buscando...',
          FEEDBACK_INSIDE_GUIDE: 'Estar dentro de la guía',
          FEEDBACK_PLEASE_HOLD: 'Por favor espere.',
          FEEDBACK_STABLE: 'Por favor sea estable',
          FEEDBACK_EYE_LEVEL: 'Mira recto',
          FEEDBACK_FACE_OUTSIDE: 'Por favor, esté dentro de la guía',
          FEEDBACK_CLOSE: 'Alejarse',
          FEEDBACK_FAR: 'Acercarse',
          FEEDBACK_LEFT_FACING: 'Mira recto',
          FEEDBACK_RIGHT_FACING: 'Mira recto',
          FEEDBACK_ROTATED: 'Mira recto',
          FEEDBACK_NOT_STABLE: 'Por favor sea estable',
          FEEDBACK_OK: 'Por favor espera',
          FEEDBACK_NO: 'Comprobación',
          FEEDBACK_NOT_CENTERED: 'Centrar la cara en el ovalo',
          FEEDBACK_CAMERA_ACQUIRING_FAILED: 'No se puede adquirir la cámara, permitir el permiso o reintentar la captura',
          FEEDBACK_PROCESSING: 'Procesando...',
          FEEDBACK_UPLOAO_FAILURE: 'Reintento de error interno',
          FEEDBACK_INITIALIZATION: 'Inicializando ...',
          FEEDBACK_CHANGE_LIGHT: 'Evita las sombras',
          FEEDBACK_BUTTON_CLOSE: 'Cerrar',
          FEEDBACK_BUTTON_RETRY: 'Reintentar',
          FEEDBACK_TRAINING_BUTTON_NEXT: 'Siguiente',
          FEEDBACK_TRAINING_LABEL: 'No volver a mostrar',
          FEEDBACK_ORIENTATION_NOT_SUPPORTED: 'Solo se admite el modo Retrato',
          ERROR_BROWSER_NOT_SUPPORTED: 'El navegador no es compatible. Actualice a la versión más reciente de Chrome, Firefox (Android) o Safari en IOS.',
          ERROR_WEBRTC_NOT_SUPPORTED: 'Webrtc no soportado',
          ERROR_MODEL_FAIL: 'Error en la detección del modelo',
          ERROR_SERVER_INTERNAL: 'Error de servidor interno',
          ERROR_SERVER_CONNECTION_FAILURE: 'Fallo de conexión al servidor'
        }
      },
      enableAS: selection.enableAS,
      requiredTemplates: selection.templates,
      showCaptureTraining: selection.showCaptureTraining,
      base64EncodingFlag: Base64.NO_WRAP,
      allowClose: true,
      transaction: {
        type: transaction
      },
      debug: true,
      asThreshold: AsThreshold.MEDIUM,
      assisted: true,
      urls: {
        modelURL: `${this.urlIdentify}/api/v1/model`
      },
      backend: 'webgl'
    };

    if (transaction === TransactionMode.VERIFY) {
      if (!options.transaction) {
        options.transaction = {};
      }
      options.transaction.id = localStorage.getItem('transactionId');
    }

    const faceSDK = new FaceSDK(options);

    faceSDK.onInit = () => {
      faceSDK.capture().then((blob: Blob) => {
        return this.postData(faceSDK, blob, transaction);
      }).catch((err) => {

        if (err instanceof LocalizationMessage) {

          if (err.code !== 202) {
            alert(err.getLocalizedString());
          }
        }

      });
    };

    faceSDK.initialize().catch((err) => {

      if (err instanceof LocalizationMessage) {
        if (err.code === 100 || err.code === 500) {
          alert(err.getLocalizedString());
        }
      }

    });
  }


  postData(sdk: FaceSDK, capresult: Blob, action: TransactionMode) {

    return new Promise<void>((resolve => {

      const fd = new FormData();
      fd.append('file', capresult, `bdata`);


      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());

      ajax({
        url: `${this.urlIdentify}/api/v1/process?ts=${new Date().getTime()}`,
        contentType: false,
        processData: false,
        method: 'POST',
        dataType: 'JSON',
        data: fd,
        headers: {
          'X-DEBUG': localStorage.getItem('lu')
        }
      }).done((response: any) => {
        console.log("response T: ...", response);

        const clientResponse = {transaction_id: response.id, code: response.code, feedback_code: response.message};
        
        let idT = clientResponse.transaction_id.toString();
        console.log("idT.....", idT);

        let userId;
        this.storageService.getStorage('userId').then((savedUserId: any) => {
          userId = savedUserId.value;
          console.log("userId", userId);
          let tokenJava;
          this.storageService.getStorage('TOKENJAVA').then((savedToken: any) => {
            this.storageService.getStorage('originalOperationId').then((savedOriginalOp) => {
              let opId = savedOriginalOp.value;
              if (opId === null) {
                this.storageService.getStorage('operationID').then((operationId) => {
                  opId = operationId.value;
                  tokenJava = savedToken.value;
                  console.log("tokenJava ", tokenJava);
                  this.bidService.contadorT(idT, opId, userId, tokenJava, "FACE", this.buildMetadata()).subscribe((data) => {
                    console.log("contadorT: ", data);
                  }, error => {
                  });
                });
              } else {
                tokenJava = savedToken.value;
                console.log("tokenJava ", tokenJava);
                this.bidService.contadorT(idT, opId, userId, tokenJava, "FACE", this.buildMetadata()).subscribe((data) => {
                  console.log("contadorT: ", data);
                }, error => {
                });

              }
            })
          });
        });
         
        const reqOp = {
          currentSecuenceId: '4',
          activityValue: 'BIO_FACE_CAPTURED'
        };

        this.bidService.updateOperation(this.operationId, reqOp).subscribe(async (data) => {
          this.loadingController.dismiss().then();
          this.storage.saveToStorage('FACEBASE64', response.data.aligned).then();
          this.router.navigateByUrl('/seleccionar-doc').then();
        });

      }).fail(async (err) => {
        let userId;
        let idT = "";
        this.storageService.getStorage('userId').then((op: any) => {
          userId = op.value;
          console.log("userId", userId);
          let tokenJava;
          this.storageService.getStorage('TOKENJAVA').then((op: any) => {
            this.storageService.getStorage('originalOperationId').then((op) => {
              let opId = op.value;
              if (opId === null) {
                this.storageService.getStorage('operationID').then((op) => {
                  opId = op.value;
                  tokenJava = op.value;
                  console.log("tokenJava ", tokenJava);
                  this.bidService.contadorT(idT, opId, userId, tokenJava, "FACE", this.buildMetadata()).subscribe((data) => {
                    console.log("contadorT: ", data);
                  }, error => {
                  });
                });
              } else {
                tokenJava = op.value;
                console.log("tokenJava ", tokenJava);
                this.bidService.contadorT(idT, opId, userId, tokenJava, "FACE", this.buildMetadata()).subscribe((data) => {
                  console.log("contadorT: ", data);
                }, error => {
                });

              }
            })
          });
        });
         
 

        this.loadingController.dismiss().then();
        const message = err.responseJSON.message;
        console.log(message);
        const alert = await this.alertController.create({
          cssClass: 'ios',
          mode: 'ios',
          header: 'Error',
          message: 'Favor de reintentar',
          buttons: [{
            text: 'Aceptar',
            handler: () => {
            }
          }]
        });

        await alert.present();

      });

    }));

  }

  capture() {
    this.runTransaction(TransactionMode.CAPTURE);
  }

  enroll() {
    this.runTransaction(TransactionMode.ENROLL);
  }

  verify() {
    this.runTransaction(TransactionMode.VERIFY);
  }

}
